export default __webpack_public_path__ + "68c0ccbc607babe6bed845fcae822b6c.png";